import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";

import type { AppDispatch, RootState } from "../store";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { default as useBreakpoints } from "./useBreakpoints";
export { default as useClickAwayListener } from "./useClickAwayListener";
export { default as useIosTapHandler } from "./useIosTapHandler";
export { default as useLongPress } from "./useLongPress";
export { default as useMapSize } from "./useMapSize";
export { default as useRefDimensions } from "./useRefDimensions";
export { default as useSimulation } from "./useSimulation";
export { default as useThrottle } from "./useThrottle";
export { default as useWindowDimensions } from "./useWindowDimensions";
